import { http } from "Utils/http";

export const FIND_ARTICLE_URL = "/api/article/findArticle";
export const FILTER_ARTICLE_URL = "/api/article/filterArticle";

export const findArticleCall = (docGroupId) =>
  http.post(FIND_ARTICLE_URL, { docGroupId });

export const filterRelatedArticlesCall = (topicId) =>
  http.post(FILTER_ARTICLE_URL, {
    searchTerm: "",
    sortOption: 1,
    topic: topicId,
    type: -1,
    year: -1
  });
